<style src="./Password.scss" lang="scss" scoped></style>
<template lang="html">
  <label
    class="component"
    :class="{'valid-fail': !isValid}">

    <div class="label">
      <span class="caption">{{ label }}</span>

      <div class="component-container">
        <slot name="icon" />

        <input
          type="password"
          class="component-input"
          v-model="inputValue"
          :placeholder="placeholder"
          @blur="runValidation"
          autocomplete="new-password"
          v-shortkey.avoid>
      </div>

      <span class="error-message" v-show="!isValid">{{ messageError[0] }}</span>
    </div>
  </label>
</template>

<script>
import ValidationMixin from '@/components/primitives/validator/validation-mixin/ValidationMixin'

export default {
  name: 'Password',
  mixins: [
    ValidationMixin
  ],
  props: {
    label: {
      default: ''
    },
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    }
  },
  data () {
    return {
      inputValue: ''
    }
  },
  watch: {
    inputValue (pValue, pOldValue) {
      if (pValue !== pOldValue) this.$emit('input', pValue)
    },
    value (pValue) {
      this.inputValue = pValue
    }
  },
  methods: {
    blur () {
      this.$emit('blur')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/password/Password.vue